import { TranslatePipe } from '@ngx-translate/core';
import { Component, OnInit } from '@angular/core';
import { Session } from '../../../_services';

@Component({
    selector: 'session-create',
    templateUrl: './create.component.html',
    styleUrls: ['./create.style.scss'],
    providers: [TranslatePipe],
})
export class SessionCreateComponent implements OnInit {
    currentSession: Session;

    ngOnInit(): void {
        this.currentSession = new Session();
        this.currentSession.id = null;
        this.currentSession.title = '';
        this.currentSession.startDate = null;
        this.currentSession.days = 0;
        this.currentSession.trainer = null;
        this.currentSession.trainerId = null;
        this.currentSession.type = 'PUBLIC';
        this.currentSession.price = 0;
        this.currentSession.priceCurrency = 'EURO';
        this.currentSession.reference = '';
        this.currentSession.location = null;
        this.currentSession.local = null;
        this.currentSession.room = null;
        this.currentSession.registrations = null;
        this.currentSession.training = null;
        this.currentSession.billing = {
            comments: '',
            deleted: false,
        };
        this.currentSession.deleted = false;
        this.currentSession.subject = null;
        this.currentSession.additionalTrainers = [];
        this.currentSession.hours = [];
        this.currentSession.synchronizeSignature = true;
    }
}



// WEBPACK FOOTER //
// ./src/app/_screens/session/create/create.component.ts